import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/giovambattistafazioli/Lavori/Github/react-toggle/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import Toggle, { ToggleProps } from '../../../src/components/Toggle';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "toggle"
    }}>{`Toggle`}</h1>
    <p>{`The Toggle component is an useful replacement to the standar input checkbox component.
Anyway, remember that the toggle component is an extension of the input checkbox. So, you can use it inside a form as well.
In fact, remember to use the props `}<inlineCode parentName="p">{`name`}</inlineCode>{` when you're using multiple toggle component in your view.`}</p>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <p>{`You can wrap the Toggle component with `}<inlineCode parentName="p">{`label`}</inlineCode></p>
    <Playground __position={0} __code={'<label htmlFor=\"toggle-1\">\n  Left label\n  <Toggle name=\"toggle-1\" />\n</label>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Toggle,
      ToggleProps
    }} mdxType="Playground">
  <label htmlFor="toggle-1">
    Left label
    <Toggle name="toggle-1" mdxType="Toggle" />
  </label>
    </Playground>
    <Playground __position={1} __code={'<label htmlFor=\"toggle-2\">\n  <Toggle name=\"toggle-2\" />\n  Right label\n</label>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Toggle,
      ToggleProps
    }} mdxType="Playground">
  <label htmlFor="toggle-2">
    <Toggle name="toggle-2" mdxType="Toggle" />
    Right label
  </label>
    </Playground>
    <p>{`Or set any `}<inlineCode parentName="p">{`label`}</inlineCode>{` outside`}</p>
    <Playground __position={2} __code={'<label htmlFor=\"toggle-1a\">Left label outside</label>\n<Toggle name=\"toggle-1a\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Toggle,
      ToggleProps
    }} mdxType="Playground">
  <label htmlFor="toggle-1a">Left label outside</label>
  <Toggle name="toggle-1a" mdxType="Toggle" />
    </Playground>
    <Playground __position={3} __code={'<Toggle name=\"toggle-2a\" />\n<label htmlFor=\"toggle-2a\">Right label outside</label>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Toggle,
      ToggleProps
    }} mdxType="Playground">
  <Toggle name="toggle-2a" mdxType="Toggle" />
  <label htmlFor="toggle-2a">Right label outside</label>
    </Playground>
    <h3 {...{
      "id": "disable"
    }}>{`Disable`}</h3>
    <Playground __position={4} __code={'<label htmlFor=\"toggle-3\">\n  Disabled\n  <Toggle name=\"toggle-3\" disabled />\n</label>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Toggle,
      ToggleProps
    }} mdxType="Playground">
  <label htmlFor="toggle-3">
    Disabled
    <Toggle name="toggle-3" disabled mdxType="Toggle" />
  </label>
    </Playground>
    <h3 {...{
      "id": "appearance"
    }}>{`Appearance`}</h3>
    <Playground __position={5} __code={'<label htmlFor=\"toggle-4\">\n  <Toggle\n    leftBackgroundColor=\"tomato\"\n    rightBackgroundColor=\"green\"\n    borderColor=\"tomato\"\n    knobColor=\"white\"\n    name=\"toggle-4\"\n    onToggle={e => console.log(\'onToggle\', e.target.checked)}\n  />\n  Appearance\n</label>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Toggle,
      ToggleProps
    }} mdxType="Playground">
  <label htmlFor="toggle-4">
    <Toggle leftBackgroundColor="tomato" rightBackgroundColor="green" borderColor="tomato" knobColor="white" name="toggle-4" onToggle={e => console.log("onToggle", e.target.checked)} mdxType="Toggle" />
    Appearance
  </label>
    </Playground>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={ToggleProps} mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      